import { render } from "./ToastAlert.vue?vue&type=template&id=3650f0ef"
import script from "./ToastAlert.vue?vue&type=script&lang=js"
export * from "./ToastAlert.vue?vue&type=script&lang=js"

import "./ToastAlert.vue?vue&type=style&index=0&id=3650f0ef&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__